<h2 mat-dialog-title class="dialog-header">Director Elections</h2>

<div mat-dialog-content>
  <ngx-spinner></ngx-spinner>

  <div class="select-all-row">
    <mat-checkbox [(ngModel)]="selectAll" (change)="onToggleSelectAll()">
      Select All / Unselect All
    </mat-checkbox>
  </div>

  <div class="candidates-table">
    <div class="table-header">
      <span class="col-name">Name</span>
      <span class="col-select">Select</span>
    </div>

    <!-- Board Members -->
    @for (candidate of candidates; track candidate.name) {
      <div class="table-row" [class.disabled-row]="candidate.disabled">
        <span class="col-name">{{ candidate.name }}</span>
        <span class="col-select">
          <mat-checkbox [(ngModel)]="candidate.selected" [disabled]="!!candidate.disabled" (change)="onCandidateChange()"></mat-checkbox>
        </span>
      </div>
    }

    <!-- Custom Input Slots -->
    @for (slot of customInputs; track $index) {
      <div class="table-row custom-row">
        <span class="col-name">
          <input type="text" [(ngModel)]="slot.name" class="custom-input" placeholder="Enter candidate name...">
        </span>
        <span class="col-select">
          <mat-checkbox [(ngModel)]="slot.selected" [disabled]="!slot.name.trim()"
                        (change)="onCustomSelectionChange(slot)"></mat-checkbox>
        </span>
      </div>
    }
  </div>
</div>

<div mat-dialog-actions class="dialog-actions">
  <button mat-flat-button color="primary" (click)="onConfirm()">
    <mat-icon>check</mat-icon>
    Apply
  </button>
  <button mat-flat-button type="button" class="nrg-error-flat-button" (click)="onCancel()">
    <mat-icon>clear</mat-icon>
    Close
  </button>
</div>
